import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'manageAll'
})
export class ManageAllPipe implements PipeTransform {

  //incorprate all option along with other filter options 
  transform(value: any, additionalvalue: any[]) {
    if(additionalvalue){
      return value.concat(additionalvalue);
    }else {
      return value;
    }
  }

}
